import { atom } from 'recoil';

export const profileMenuOpenAtom = atom<boolean>({
  key: 'profileMenuOpenAtom',
  default: false,
});
